export default __webpack_public_path__ + "static/Q&A_booklet-33fe359bf1acb997dc7103a240ff4f5d.pdf";